import { Divider, Flex, ListItem, Text, UnorderedList } from '@chakra-ui/react';
import { Trans } from '@lingui/macro';

import { formatDate } from '../../utils/dateUtil';

const PartnerFfvLicenses = ({ licenses }) => {
  const hasLicenses = licenses != null && licenses.length > 0;
  return (
    <>
      <Divider />

      <Text color="brand.color_main" fontSize="sm">
        <Trans>Your licenses</Trans>
      </Text>

      {!hasLicenses && (
        <Text>
          <Trans>You have no valid license for those dates.</Trans>
        </Text>
      )}

      {hasLicenses && (
        <UnorderedList ml="80px" w="full">
          {licenses.map((item, idx) => (
            <ListItem key={idx}>
              <Text fontWeight="bold">
                {item.typeTitre} ({item.titreId})
              </Text>

              <Flex flexDirection="row" gap={1} fontSize="xs" opacity=".6">
                <Text>
                  <Trans>Valid from</Trans>
                </Text>
                {formatDate(item.dateValiditeDebut, {
                  dateStyle: 'medium',
                })}
                {' (' +
                  formatDate(item.dateValiditeDebut, {
                    timeStyle: 'short',
                  }) +
                  ')'}
                <Text>
                  <Trans context="date at (au)">to</Trans>
                </Text>
                {formatDate(item.dateValiditeFin, {
                  dateStyle: 'medium',
                })}
                {' (' +
                  formatDate(item.dateValiditeFin, {
                    timeStyle: 'short',
                  }) +
                  ')'}
              </Flex>
            </ListItem>
          ))}
        </UnorderedList>
      )}
    </>
  );
};

export default PartnerFfvLicenses;
